<template>
  <div v-if="!isLocationChange && !isCalendarChange">
    <div v-if="!variants">
      <div class="catalog__categories" v-if="cars && cars.available_car_classes">
        <a class="categories-label" v-bind:class="{'categories-label--active': category.includes(cat.id)}" v-for="cat in cars.available_car_classes" v-bind:key="cat.id" href="javascript:void(0)" @click="setCategory(cat.id)">{{cat.name}}</a>
      </div>
      <Loader class="w-100" v-if="loading.cars" />
      <div v-else>
        <!-- <PromoCode /> -->
        <div class="catalog__cars" v-if="cars && cars.vehicles.length > 0">
          <a class="catalog-car" v-bind:class="{'catalog-car--multiple': car.vehicles}" href="javascript:void(0)" v-for="car in cars.vehicles" v-bind:key="car.id">
            <div v-if="car.vehicle" @click="setCar(car.vehicle)">
              <div class="catalog-car__photo">
                <div class="catalog-car__photo-image" :style="`background-image: url(${car.vehicle.car_model_thumbnail})`"></div>
              </div>
              <div class="catalog-car__name">{{car.model}}</div>
              <div class="catalog-car__footer">
                <div class="catalog-car__price"><span class="catalog-car__price-old" v-if="car.vehicle.rate_per_day_old">{{formatPrice(car.vehicle.rate_per_day_old)}} <i class="rouble-sign">₽</i></span> {{formatPrice(car.vehicle.rate_per_day)}} <i class="rouble-sign">₽</i>/сутки</div>
              </div>
            </div>
            <div v-if="car.vehicles" @click="setVariants(car)">
              <div class="catalog-car__photo">
                <div class="catalog-car__photo-image" :style="`background-image: url(${car.thumbnail})`"></div>
              </div>
              <div class="catalog-car__name">{{car.model}}</div>
              <div class="catalog-car__footer">
                <div class="catalog-car__price">от {{formatPrice(car.rate_per_day_min)}} <i class="rouble-sign">₽</i>/сутки</div>
              </div>
            </div>
          </a>
          <div class="catalog-car"></div>
        </div>
        <div class="pt-5 pb-5 mt-5 mb-5 w-100 text-center" v-else>
          <h2>Автомобилей не найдено</h2>
        </div>
      </div>
    </div>
    <div class="car__variations" v-else>
      <div class="car__variations-header" @click="clearVariants">
        <div class="car__variations-back"></div>
        <div class="car__variations-title">{{variants.model}}</div>
      </div>
      <div class="car__variations-text">Мы нашли несколько вариантов {{variants.model}}. Выберите наиболее подходящий.</div>
      <div class="car__variations-list">
        <div class="catalog__cars">

          <a class="catalog-car" href="javascript:void(0)" v-for="car in variants.vehicles" @click="setCarVariant(car)">
            <div class="catalog-car__photo">
              <div class="catalog-car__photo-image" :style="`background-image: url(${car.car_model_thumbnail})`"></div>
            </div>
            <div class="catalog-car__name">{{car.model}} <span v-if="car.year">({{car.year}})</span></div>
            <div class="catalog-car__footer">
              <div class="catalog-car__price"><span class="catalog-car__price-old" v-if="car.rate_per_day_old">{{formatPrice(car.rate_per_day_old)}} <i class="rouble-sign">₽</i></span> {{formatPrice(car.rate_per_day)}} <i class="rouble-sign">₽</i>/сутки</div>
            </div>
          </a>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader';
// import PromoCode from '@/components/PromoCode';

export default {
    name: 'Catalog',
    components: {
      Loader,
      // PromoCode,
    },
    data() {
      return {
        focused: false,
      }
    },
    computed: {
      isCalendarChange() {
        return this.$store.getters.isCalendarChange;
      },
      isLocationChange() {
        return this.$store.getters.isLocationChange;
      },
      variants() {
        return this.$store.getters.variants;
      },
      category() {
        return this.$store.getters.category;
      },
      cars() {
        return this.$store.getters.cars;
      },
      loading() {
        return this.$store.getters.locationsLoading;
      },
    },
    methods: {
      formatPrice(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      },
      setCar(car) {
          this.$store.dispatch('setCar', car);
          this.$router.push({ query: Object.assign({}, this.$route.query, {
            car: car.id,
          })});
      },
      setCarVariant(car) {
          this.$store.dispatch('setCar', car);
          this.$store.dispatch('clearVariants');
          this.$router.push({ query: Object.assign({}, this.$route.query, {
            car: car.id,
          })});
      },
      clearVariants(car) {
        this.$store.dispatch('clearVariants');
        let query = Object.assign({}, this.$route.query);
        delete query.variants;
        this.$router.replace({ query });
      },
      setVariants(car) {
        this.$store.dispatch('setVariants', car);
        this.$router.push({ query: Object.assign({}, this.$route.query, {
          variants: true,
        })});
      },
      setCategory(id) {
          if (this.category.includes(id)) {
            this.$store.dispatch('removeCategory', id).then(() => {
              this.$store.dispatch('getCars');
              this.$router.push({ query: Object.assign({}, this.$route.query, {
                cats: JSON.stringify(this.category),
              })});
            });
          } else {
            this.$store.dispatch('setCategory', id).then(() => {
              this.$store.dispatch('getCars');
              this.$router.push({ query: Object.assign({}, this.$route.query, {
                cats: JSON.stringify(this.category),
              })});
            });
          }
      },
    }
}
</script>